import React from "react";
import './style/contact.css'

function Contact() {
  return (
    <div className="contact">
      <section className="first">
        <p>contact</p>
        <h1>Contactez-nous</h1>
        <div className="icons">
          <a target="_blank" href="https://www.instagram.com/hamza_khazrri/">
            <img src="images/insta.svg" alt="" />
          </a>
          <a target="_blank" href="https://www.linkedin.com/in/hamza-khazri/">
            <img src="images/linkedin.svg" alt="" />
          </a>
          <a target="_blank" href="mailto:hamza20251026@gmail.com">
            <img src="images/gmail.svg" alt="" />
          </a>
        </div>
      </section>
      <section className="second">
        <form
          action="https://formsubmit.co/hamza20251026@gmail.com"
          method="POST">
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
          />
          <input type="text" name="_subject"  placeholder="Sujet"/>
          <textarea
            placeholder="Message"
            name="message"
            rows="3"
            required></textarea>
          <input type="hidden" name="_captcha" value="false" />
          <button type="submit">Envoyer</button>
        </form>
      </section>
    </div>
  );
}

export default Contact;
